var map = {
	"./app-icon.svg": 1683,
	"./caret-right-icon.svg": 1684,
	"./chrome-icon.webp": 1685,
	"./edge-icon.webp": 1686,
	"./firefox-icon.webp": 1687,
	"./opera-icon.webp": 1688,
	"./safari-icon.webp": 1689,
	"./unknown-icon.webp": 1690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1682;